import { BehaviorSubject } from 'rxjs';

export default class DrawerRepository {
  drawerDetails$ = new BehaviorSubject(null);

  loadDrawer(component, props = {}, anchor = 'right', open = true) {
    const details = {
      anchor,
      component,
      open,
      props,
    };
    this.drawerDetails$.next(details);
  }

  toggleDrawer(open) {
    const details = this.drawerDetails$.getValue();
    if (details) {
      this.drawerDetails$.next({ ...details, open });
    }
  }
}
